import axios from 'axios';
import store from '@/store';
import { smallNotification } from '@/shared-modules/services/gf.notification.service';

export default {
  cancelAutoMergeForMergeRequestItem(alias, projectAlias, id, enableAutoMerge) {
    return axios
      .post(
        `/api/project/${alias}/${projectAlias}/merge-request/${id}/${enableAutoMerge}/auto-merge`
      )
      .then((res) => {
        if (!enableAutoMerge) {
          smallNotification('info', { title: 'Автоматическое слияние выключено' });
        }
        else {
          smallNotification('info', { title: 'Автоматическое слияние включено' });
        }
        if (store) store.dispatch('selectMergeRequest', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
      });
  }
};
